module.exports = __webpack_public_path__ + "static/media/Integration-Indeed@2x.e6cbf10a.png";